import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MOCK_REQUESTS } from '../../data/mockData';
import SafeIcon from '../../common/SafeIcon';
import { FiCheck, FiX, FiClock, FiShield } from 'react-icons/fi';

export default function Access() {
  const [requests, setRequests] = useState(MOCK_REQUESTS);

  const handleAction = (id, action) => {
    setRequests(prev => prev.map(req => 
      req.id === id ? { ...req, status: action } : req
    ));
  };

  const pendingCount = requests.filter(r => r.status === 'pending').length;

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="h-full flex flex-col">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-bold text-[var(--pearl)] mb-1">Access Bay</h2>
          <p className="text-[var(--pearl-muted)] text-sm">Manage crew permissions and data boarding requests.</p>
        </div>
        <div className="px-4 py-2 bg-[var(--surface-ocean-light)] border border-[var(--border-ocean)] rounded-md text-sm text-[var(--pearl)]">
          Pending Approvals: <span className="text-[var(--schema-teal)] font-bold">{pendingCount}</span>
        </div>
      </div>

      <div className="glass-panel flex-1 overflow-hidden flex flex-col p-6">
        <h3 className="text-lg font-semibold mb-4 text-[var(--schema-teal)] flex items-center gap-2">
            <SafeIcon icon={FiShield} /> Authorization Queue
        </h3>
        <div className="space-y-4 overflow-auto flex-1 pr-2">
          <AnimatePresence>
            {requests.map((req) => (
              <motion.div 
                key={req.id}
                layout
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95, transition: { duration: 0.2 } }}
                className={`p-4 rounded-lg border flex flex-col md:flex-row justify-between items-start md:items-center gap-4 transition-colors ${
                  req.status === 'pending' 
                    ? 'bg-[var(--surface-ocean-light)] border-[var(--border-ocean)]' 
                    : req.status === 'approved'
                    ? 'bg-[var(--success-mint)]/10 border-[var(--success-mint)]/30'
                    : 'bg-[var(--alert-coral)]/10 border-[var(--alert-coral)]/30'
                }`}
              >
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-1">
                    <span className="font-semibold text-[var(--pearl)]">{req.user}</span>
                    <span className="text-xs px-2 py-0.5 rounded bg-[var(--bg-ocean)] text-[var(--pearl-muted)] border border-[var(--border-ocean)]">{req.role}</span>
                    <span className="text-xs text-[var(--pearl-muted)] flex items-center gap-1">
                        <SafeIcon icon={FiClock} /> {req.date}
                    </span>
                  </div>
                  <p className="text-sm text-[var(--pearl)] mt-2">
                    Requested boarding to: <span className="text-[var(--schema-teal)] font-mono">{req.dataset}</span>
                  </p>
                  <p className="text-xs text-[var(--pearl-muted)] mt-1 italic">"{req.reason}"</p>
                </div>

                {req.status === 'pending' ? (
                  <div className="flex gap-2 w-full md:w-auto">
                    <button 
                      onClick={() => handleAction(req.id, 'denied')}
                      className="flex-1 md:flex-none px-3 py-1.5 rounded border border-[var(--alert-coral)] text-[var(--alert-coral)] hover:bg-[var(--alert-coral)] hover:text-white transition-colors text-sm flex items-center justify-center gap-1"
                    >
                      <SafeIcon icon={FiX} /> Deny
                    </button>
                    <button 
                      onClick={() => handleAction(req.id, 'approved')}
                      className="flex-1 md:flex-none px-3 py-1.5 rounded border border-[var(--success-mint)] text-[var(--success-mint)] hover:bg-[var(--success-mint)] hover:text-[#030811] transition-colors text-sm flex items-center justify-center gap-1 hover:shadow-[0_0_10px_var(--success-mint)]"
                    >
                      <SafeIcon icon={FiCheck} /> Approve
                    </button>
                  </div>
                ) : (
                  <div className={`px-3 py-1 rounded text-xs font-bold uppercase tracking-wider ${
                    req.status === 'approved' ? 'text-[var(--success-mint)]' : 'text-[var(--alert-coral)]'
                  }`}>
                    {req.status}
                  </div>
                )}
              </motion.div>
            ))}
          </AnimatePresence>
          {requests.length === 0 && (
            <div className="text-center py-10 text-[var(--pearl-muted)]">
                Queue is empty.
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
}